const point = {
    methods: {
        numberFormat(number, withCurrency = false) {

            let numberString = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            if(withCurrency === true) {

                numberString += '円';

            }

            return numberString;

        }
    }
};

const payment = {
    data() {
        return {
            stripe: null,
            stripeCard: null,
            paymentMethods: [],
            paymentType: 'stored', // `stored` or `new`
            errorMessage: ''
        }
    },
    methods: {
        async getSubscriptionPaymentMethod(target) {

            const clientSecret = target.dataset.secret;
            return await this.stripe.confirmCardSetup(
                clientSecret, {
                    payment_method: {
                        card: this.stripeCard,
                        billing_details: { name: this.cardHolderName }
                    }
                }
            );

        },
        async getSinglePaymentMethod() {

            return await this.stripe.createPaymentMethod(
                'card', this.stripeCard, {
                    billing_details: { name: this.cardHolderName }
                }
            );

        },
        initStripe(publicKey) {

            this.stripe = Stripe(publicKey);

        },
        mountStripe(selector) {

            this.stripeCard = this.stripe.elements().create('card', {
                hidePostalCode: true
            });
            this.stripeCard.mount(selector);

        },
        setStripeError(error) {

            if(error.code === 'parameter_invalid_empty') {

                this.errorMessage = 'カード名義人は必須です。';

            } else {

                this.errorMessage = error.message;

            }

        },
    },
    computed: {
        isPaymentTypeStored() {

            return (this.paymentType === 'stored');

        },
        isPaymentTypeNew() {

            return (this.paymentType === 'new');

        },
        hasPaymentMethod() {

            return (this.paymentMethods.length > 0);

        }
    },
    watch: {
        paymentMethods: {
            immediate: true,
            handler(values) {

                this.paymentType = (values.length > 0) ? 'stored' : 'new';

            }
        }
    },
};

const ajax = {
    data() {
        return {
            params: {},
            originalParams: {},
            ajaxSuccessMessage: '',
            currentAjaxId: -1,
            ajaxSubmitting: false
        }
    },
    methods: {
        onFileChange(file, key) {

            this.params[key] = file;

        },
        onAjaxSubmit(confirmMessage = '') {

            if(confirmMessage === '') {

                confirmMessage = '送信します。よろしいですか？';

            }

            if(confirm(confirmMessage)) {

                this.errors = {};
                this.ajaxSuccessMessage = '';
                this.ajaxSubmitting = true;
                const params = this.getAjaxParams();

                axios.post(this.ajaxUrl, params)
                    .then(response => {

                        if(response.data.result === true) {

                            this.ajaxSuccessMessage = '保存が完了しました';

                            if(this.isAjaxCreate) {

                                this.clearAjaxParams();

                            }

                            if(this.ajaxRedirectUrl) {

                                location.href = this.ajaxRedirectUrl;

                            } else {

                                $('html,body').animate({
                                    scrollTop: 0
                                }, 'fast');

                                setTimeout(() => {

                                    this.ajaxSuccessMessage = '';

                                }, 5000); // 5 sec

                            }

                        }

                    })
                    .catch(error => {

                        _.each(error.response.data.errors, (messages, key) => {

                            Vue.set(this.errors, key, messages[0]);

                        });

                        Vue.nextTick(() => {

                            if($('.v-error').length > 0) {

                                const top = $('.v-error:first').offset().top - 100;
                                $('html,body').animate({
                                    scrollTop: top
                                }, 'fast');

                            }

                        });

                    })
                    .finally(() => {

                        this.ajaxSubmitting = false;

                    });

            }

        },
        clearAjaxParams() {

            this.params = Object.assign({}, this.originalParams);

        },
        getAjaxParams() {

            let formData = new FormData();

            _.each(this.params, (value, key) => {

                if(value !== null) {

                    formData.append(key, value)

                }

            });

            if(this.isAjaxEdit) {

                formData.append('_method', 'PUT');

            }

            return formData;

        },
        setAjaxId() {

            const hash = window.location.hash;
            const matches = hash.match(/^#([0-9]+)$/);
            this.currentAjaxId = (matches) ? parseInt(matches[1]) : -1;

        }
    },
    computed: {
        ajaxUrl() {

            console.log('Overwrite ajaxUrl() in computed!');

        },
        ajaxRedirectUrl() {},
        isAjaxCreate() {

            return (!this.currentAjaxId || this.currentAjaxId < 1);

        },
        isAjaxEdit() {

            return (this.currentAjaxId > 0);

        }
    },
    mounted() {

        this.originalParams = Object.assign({}, this.params);
        this.setAjaxId();
        window.onhashchange = this.setAjaxId;

    }
};

// Need an input tag as follows
// <input id="image_upload" class="d-none" type="file" accept="image/png,image/jpeg" @change="onEditorImageChange">
const richEditor = {
    data() {
        return {
            editorSelector: '#editor',
            editorUploadUrl: '/ruler/announcement/upload_image',
            editorInit: false,
            editorImageUploading: false,
            quill: null
        }
    },
    methods: {
        initEditor(defaultHtml = '') {

            this.editorInit = false;

            if(this.quill === null) {

                this.quill = new Quill(this.editorSelector, {
                    modules: {
                        syntax: false,
                        toolbar: {
                            container: [
                                [{ size: [] }],
                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                [{ list: 'ordered' }, { list: 'bullet' }],
                                [{ align: [] }],
                                ['link', 'image', 'video'],
                            ],
                            handlers: {
                                image: this.onUploadImageClick
                            }
                        }
                    },
                    theme: 'snow'
                });

            }

            this.setEditorHtml(defaultHtml);

        },
        setEditorHtml(html) {

            this.quill.root.innerHTML = html;

        },
        getEditorHtml() {

            const html = this.quill.root.innerHTML;

            if(html === '<p><br></p>') {

                return '';

            }

            return html;

        },
        onUploadImageClick() {

            document.querySelector('#image_upload').click();

        },
        onEditorImageChange(e) {

            const files = e.target.files;

            if(files.length > 0) {

                this.editorImageUploading = true;
                const file = files[0];
                const url = this.editorUploadUrl;
                let formData = new FormData();
                formData.append('image', file);

                axios.post(url, formData)
                    .then(response => {

                        if(response.data.result === true) {

                            const imageUrl = response.data.image_url;
                            const selection = this.quill.getSelection();
                            this.quill.insertEmbed(selection.index, 'image', imageUrl);

                        }

                    })
                    .catch(error => {

                        alert('画像のアップロードに失敗しました');

                    })
                    .finally(() => {

                        this.editorImageUploading = false;

                    });

            }

        }
    },
    mounted() {

        window.onbeforeunload = () => {

            if(this.isStatusCreate || this.isStatusEdit) {

                return '未保存のデータがあります。処理を実行しますか？';

            }

        };

    }
};

const announcement = {
    data() {
        return {
            status: 'index',
            announcementReads: {},
            announcementListUrl: '', // Must set!
            announcementFindUrl: '', // Must set!
            currentAnnouncementRead: {},
            announcementPage: 1
        }
    },
    methods: {
        getAnnouncements() {

            const url = `${this.announcementListUrl}?page=${this.announcementPage}`;
            axios.get(url)
                .then(response => {

                    this.announcementReads = response.data;

                    Vue.nextTick(() => {

                        $('html,body').animate({
                            scrollTop: 0
                        }, 'fast');

                    });

                });

        },
        getListClasses(announcementRead) {

            let classes = ['announcement-list-item'];

            if(!announcementRead.read) {

                classes.push('announcement-list-item-unread');

            }

            return classes;

        },
        onHashChange() {

            const locations = location.href.split('#');
            let hash = locations[1] || '';
            let hashItems = hash.split(':');
            const status = hashItems[0] || 'index';
            const value = hashItems[1] || '';

            if(status === 'show') {

                this.currentAnnouncementRead = {};
                const url = this.announcementFindUrl +'/'+ value;
                axios.get(url)
                    .then(response => {

                        if(!_.isEmpty(response.data)) {

                            this.currentAnnouncementRead = response.data;

                        } else {

                            throw new Error();

                        }

                    })
                    .catch(error => {

                        this.currentAnnouncementRead = {
                            announcement: {
                                title: 'データが見つかりません',
                                description: '残念ながら、指定されたデータはすでに削除されたか有効ではありません。'
                            }
                        };

                    })
                    .finally(() => {

                        this.getAnnouncements();

                        setTimeout(() => {

                            $('#announcement-list-item-'+ value).removeClass('bg-light-gray');

                        }, 2000);

                    });

            }

            this.status = status;

        }
    },
    computed: {
        hasAnnouncementRead() {

            return (
                this.currentAnnouncementRead &&
                Object.keys(this.currentAnnouncementRead).length > 0
            );

        },
        isStatusIndex() {

            return (this.status === 'index');

        },
        isStatusShow() {

            return (this.status === 'show');

        }
    },
    mounted() {

        window.onhashchange = this.onHashChange;
        this.onHashChange();

        if(this.isStatusIndex) {

            this.getAnnouncements();

        }

    }
};

const pusher = {
    data() {
        return {
            Echo: null,
            pusherOptions: {
                key: '',
                cluster: '',
                authUrl: ''
            }
        }
    },
    created() {

        const key = this.pusherOptions.key;
        const cluster = this.pusherOptions.cluster;
        const authUrl = this.pusherOptions.authUrl;

        if(key === '' || cluster === '' || authUrl === '') {

            console.log('You need to set pusher_app_key, pusher_app_cluster and broadcastUrl.');

        } else {

            this.Echo = new Echo({
                broadcaster: 'pusher',
                key: key,
                cluster: cluster,
                encrypted: true,
                authEndpoint: authUrl
            });

        }

    }
};

const sound = {
    methods: {
        makeSound(soundUrl = '/ogg/notification.ogg') {

            const isIphone = /iPhone/i.test(navigator.userAgent);

            if(isIphone === false) { // iPhone は除外

                document.querySelectorAll('.notification-iframe').forEach(el => el.remove());

                const iFrame = document.createElement('iframe');
                iFrame.setAttribute('src', soundUrl);
                iFrame.setAttribute('allow', 'autoplay');
                iFrame.style.display = 'none';
                iFrame.className = 'notification-iframe';
                document.body.appendChild(iFrame);

            }

        },
    }
};

const breakpoint = {
    methods: {
        getBreakpoint() {

            const windowWidth = window.innerWidth;
            let breakpoint;

            if(windowWidth >= 1200) {

                breakpoint = 'xl'

            } else if(windowWidth >= 992) {

                breakpoint = 'lg'

            } else if(windowWidth >= 768) {

                breakpoint = 'md'

            } else if(windowWidth >= 576) {

                breakpoint = 'sm'

            } else {

                breakpoint = 'xs'

            }

            return breakpoint;

        }
    }
};

export {
    point,
    payment,
    ajax,
    richEditor,
    announcement,
    pusher,
    sound,
    breakpoint
};
